// import Vue from 'vue'
import Vuex from 'vuex'
import helpers from './modules/helpers';
import localidade from './modules/localidade';
import especialistas from './modules/especialistas';

// Vue.use(Vuex)

export default new Vuex.Store({
    modules: {
        helpers,
        localidade,
        especialistas
    }
})
